import { MultilineTextBox, MultilineTextBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const PropertyNotesField = () => {
    const value = useWizardDemoStore((state) => state.property.propertyNotes);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <MultilineTextBox
            id='propertyNotes'
            value={value}
            onChange={(notes) => updateProperty({ propertyNotes: notes ?? '' })}
            label='Property Notes'
            required={true}
            width={'100%'}
            height='96px'
            placeholder='Notes about the property'
            layoutStyle={MultilineTextBoxLayoutStyle.Horizontal}
        />
    );
};
